import React from 'react';
import "./assets/styles/index.scss"
import "./utils/helpers/i18n";
import {CookiesProvider} from "react-cookie";
import {Theme} from "./assets";
import {ConfigProvider, App as AntdApp} from "antd";
import { StyleProvider } from "@ant-design/cssinjs";
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import {ROUTES_CONFIG} from "./utils/config/routes.config";
import {LangProvider} from "./utils/context/lang";
import {Provider} from "react-redux";
import {store} from "./utils";


function App() {
  const router = createBrowserRouter(ROUTES_CONFIG);
  
  return (
    <CookiesProvider>
      <Provider store={store}>
        <ConfigProvider theme={Theme}>
          <StyleProvider hashPriority="high">
            <LangProvider>
              <AntdApp style={{maxHeight: "100vh", overflow: 'hidden', height: '100%'}}>
                <RouterProvider router={router}/>
              </AntdApp>
            </LangProvider>
          </StyleProvider>
        </ConfigProvider>
      </Provider>
    </CookiesProvider>
  );
}

export default App;
